import {useApprovedReviews} from './data/use-approved-reviews'
import {ForYouReviewCommentItem} from '../commenting/review-comments/ForYouReviewComment'

export function Approved() {
  const approvedReviews = useApprovedReviews()

  if (approvedReviews.length === 0) {
    return null
  }

  return (
    <>
      {approvedReviews.map(reviewSummary => (
        <ForYouReviewCommentItem key={reviewSummary.id} reviewSummary={reviewSummary} />
      ))}
    </>
  )
}
